import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class HeaderComponent {
    constructor() {
        HeaderComponent.swiper_banner()
    }

    static async swiper_banner() {
        const swiperItem = '[data-swiper="banner"]'
        const slideItem = '[data-swiper="banner"] > div'

        const options = {
            slidesPerView: 'auto',
            autoplay: {
                delay: 3000,
            },
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            pagination: {
                el: '#swiper-banner-pagination',
                type: 'bullets',
                clickable: true,
            },
            mousewheel: {
                forceToAxis: true,
            },
            grabCursor: true,
            loop: true,
            on: {
                activeIndexChange: (e) => {
                    const index = e.activeIndex - 1
                    $('[data-swiper-banner-caption]')
                        .removeClass('is-active')
                        .eq(index)
                        .addClass('is-active')
                },
            },
        }

        $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')

        await Swiper.create('[data-swiper="banner"]', options)
    }
}
